import React from "react";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { useRecoilValue } from "recoil";
import { PERMISSIONS } from "../../../PermissionsConstants";
import DistributionChannelTable from "./DistributionChannelTable";

const DistributionChannel = () => {
  const viewPermission = PERMISSIONS.permission_utilities_carrierprogram_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <div>
      {/* {userPermissions.includes(viewPermission) && <CarrierProgramTable />} */}
      <DistributionChannelTable />
    </div>
  );
};

export default DistributionChannel;
